import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { tokens } from "@/tokens";

interface SeverityDotProps {
  severity: "high" | "medium" | "low";
  showLabel?: boolean;
  size?: number;
}

const SEVERITY_CONFIG = {
  high: { bg: tokens.status.danger, char: "!", label: "High" },
  medium: { bg: tokens.status.warning, char: "\u2013", label: "Medium" },
  low: { bg: tokens.status.info, char: "\u2013", label: "Low" },
} as const;

const SeverityDot: React.FC<SeverityDotProps> = ({
  severity,
  showLabel = true,
  size = 18,
}) => {
  const key = (severity?.toLowerCase() ?? "low") as "high" | "medium" | "low";
  const config = SEVERITY_CONFIG[key] || SEVERITY_CONFIG.low;

  return (
    <Stack direction="row" alignItems="center" gap={0.75}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          bgcolor: config.bg,
          color: tokens.bg.surface,
          fontWeight: tokens.fontWeight.heavy,
          fontSize: `${Math.round(size * 0.56)}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 1,
          flexShrink: 0,
        }}
      >
        {config.char}
      </Box>
      {showLabel && (
        <Typography
          sx={{
            fontSize: tokens.fontSize.base,
            fontWeight: tokens.fontWeight.semibold,
            color: config.bg,
            lineHeight: 1,
          }}
        >
          {config.label}
        </Typography>
      )}
    </Stack>
  );
};

export default SeverityDot;
